import { ValidationMessageType } from "../enums";

//constructs a validation message
export const ValidationMessageExceedLimit = (
  limit,
  messageType = ValidationMessageType.Error,
  fieldName = "Value"
) => ({
  messageType: messageType,
  message: `${fieldName} should not exceed limit of ${limit}`
});
